module.exports = __webpack_public_path__ + "static/media/Bitcoin.32b712ec.svg";